<template>
  <div v-if="isVisible" class="popup" @click="$emit('click', $event)">
    {{ message || $t('errors.default') }}
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped src="./errorPopup.css"></style>
